const infoList = [
  {
    name: '摘要',
    type: 'content',
    content: '',
    imgs: []
  },
  {
    name: '著录项信息',
    type: 'form',
    form: [
      {
        key: 'application_num_sear',
        label: '申请号',
        value: ''
      },
      {
        key: 'application_date',
        label: '申请日',
        value: ''
      },
      {
        key: 'publication_number_sear',
        label: '公开号',
        value: ''
      },
      {
        key: 'publication_date',
        label: '公开日',
        value: ''
      },
      {
        key: 'applicants_normal_stat',
        label: '申请人',
        value: ''
      },
      {
        key: 'applicant_addr',
        label: '申请人地址',
        value: ''
      },
      {
        key: 'province_name',
        label: '申请人省/直辖市',
        value: ''
      },
      {
        key: 'application_country',
        label: '申请国家/地区',
        value: ''
      },
      {
        key: 'inventors',
        label: '发明人',
        value: ''
      },
      {
        key: 'agent',
        label: '代理人',
        value: ''
      },
      {
        key: 'agency',
        label: '代理机构',
        value: ''
      },
      {
        key: 'claims_num',
        label: '权利要求数',
        value: ''
      },
      {
        key: 'patent_duration',
        label: '专利维持期',
        value: ''
      },
      {
        key: 'expired_date',
        label: '失效日期',
        value: ''
      }
    ]
  },
  {
    name: '分类信息',
    type: 'form',
    form: [
      {
        key: '',
        label: 'IPC分类号',
        value: ''
      },
      {
        key: '',
        label: '国民经济分类号',
        value: ''
      }
    ]
  },
  {
    name: '法律信息',
    type: 'table',
    columns: [
      {
        title: '法律事件公开日',
        dataIndex: 'legal_date',
        width: 200
      },
      {
        title: '法律事件',
        dataIndex: 'legal_status',
        width: 200
      },
      {
        title: '法律事件信息',
        dataIndex: 'event_details'
      }
    ],
    table: []
  },
  {
    name: '同族信息',
    type: 'form',
    form: [
      {
        key: 'familyArr',
        label: '同族专利公开号',
        value: ''
      }
    ]
  }
]
const tabList = [
  {
    tab: '基本信息',
    component: 'BaseInfos',
    key: 'baseInfos',
    disabled: false
  },
  {
    tab: '权利要求', component: 'Power', key: 'power', disabled: true
  },
  {
    tab: '说明书',
    component: 'InstructionBook',
    key: 'instructionBook',
    disabled: true
  },
  {
    tab: '说明书附图',
    component: 'InstructionFigure',
    key: 'instructionFigure',
    disabled: true
  },
  {
    tab: '专利原文',
    component: 'OriginalText',
    key: 'originalText',
    disabled: true
  }
  // {
  //   tab: '引证信息', component: 'Quote', key: 'Quote', disabled: true
  // }
]
const requestCols = [
  {
    alias: 'publication_number'
  },
  {
    alias: 'application_num'
  },
  {
    alias: 'title'
  },
  {
    alias: 'patent_status'
  },
  {
    alias: 'last_legal_status'
  },
  {
    alias: 'publication_date'
  },
  {
    alias: 'application_date'
  },
  {
    alias: 'applicants_normal_stat'
  },
  {
    alias: 'applicants_stat'
  },
  {
    alias: 'patent_type_cn_stat'
  },
  {
    alias: 'main_cpc_num'
  },
  {
    alias: 'abstract_ab'
  },
  {
    alias: 'inventors'
  },
  {
    alias: 'assignees_normal_stat'
  },
  {
    alias: 'assignees_stat'
  },
  {
    alias: 'application_country'
  },
  {
    alias: 'country_name'
  },
  {
    alias: 'province_name'
  },
  {
    alias: 'priority_num'
  },
  {
    alias: 'publication_type'
  },
  {
    alias: 'agent'
  },
  {
    alias: 'agency'
  },
  {
    alias: 'applicant_addr'
  },
  {
    alias: 'description'
  },
  {
    alias: 'claims_num'
  },
  {
    alias: 'claims'
  },
  {
    alias: 'patent_duration'
  },
  {
    alias: 'expired_date'
  },
  {
    alias: 'award_sess'
  },
  {
    alias: 'award_name'
  },
  {
    alias: 'priority_date'
  },
  {
    alias: 'ipc_main'
  },
  {
    alias: 'ipc_la'
  },
  {
    alias: 'ipc_li'
  },
  {
    alias: 'cpc_fi'
  },
  {
    alias: 'cpc_la'
  },
  {
    alias: 'cpc_li'
  },
  {
    alias: 'loc'
  },
  {
    alias: 'icnea_type'
  },
  {
    alias: 'icnea1_stat'
  },
  {
    alias: 'icnea2_stat'
  },
  {
    alias: 'icnea3_stat'
  },
  {
    alias: 'icnea4_stat'
  },
  {
    alias: 'family_info'
  },
  {
    alias: 'citation_info'
  },
  {
    alias: 'cited_info'
  },
  {
    alias: 'legal_event_status_json'
  },
  {
    alias: 'per_index'
  },
  {
    alias: 'pub_index'
  },
  {
    alias: 'group_index'
  },
  { alias: 'application_date', sortType: 'DESC' }
]
const fileList = [
  {
    publicNum: 'CN113723666A',
    pdfFile: [
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/pdf/CN-113723666-A-20211130.pdf?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=XmE9NsOocPc6AYBEYpdvJPYwNko%3D',
        extend: 'PDF'
      }
    ],
    zyFile: {
      filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/zy/AB_CN113723666A.GIF?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=53jX2%2B8u2aR4IdyoBYbtz4gkeFI%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
      extend: 'GIF'
    },
    smsFile: [
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/202110842557.GIF?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=s%2FrmPLklsxPXOLvQLpKKc%2B%2Blxe8%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/210726141019.GIF?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=XFk%2BevtfQ4uT7bof21R5JEjsDGo%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/BDA0003179558570000021.GIF?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=03MbP%2FBzvTJ%2Bew8bDm9f7pt%2Bnyw%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/BDA0003179558570000031.GIF?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=xb1pNnJxiPFEagUKu7VMuuA7OTw%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/BDA0003179558570000032.GIF?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=TUkLDQcEAaNcdYXJc%2FX%2Fga9pEg4%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/BDA0003179558570000041.GIF?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=3weY8f6mg1swt0BgIFO%2FEr%2BqIiM%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/BDA0003179558570000042.GIF?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=dX%2FthmZHiDI%2BCGS5Q02fqplPVPY%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/BDA0003179558570000043.GIF?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=6V6LvI0UM4o%2ByiZEc2fsQNqDb04%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/BDA0003179558570000051.GIF?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=SSHPt5OGXmMwuOxSjrGC0CPU2to%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/BDA0003179558570000052.GIF?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=T5K65Im9z%2BEA%2FavVCVzFT7PNT6k%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/BDA0003179558570000053.GIF?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=ONn%2FVqp4YjNoNx%2FBpysIA8YVA8M%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/BDA0003179558570000054.GIF?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=6yTl88hL8APlAqw0EfIFryp2qxw%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/BDA0003179558570000055.GIF?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=WQ6rrPvn4HWWR04XGIYpo9kuPu8%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/BDA0003179558570000056.GIF?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=PYHW9iMpRuZX2Ew3NOth5TrWqf0%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/BDA0003179558570000061.GIF?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=HGANT1ipFKQQ5Ry%2BZlpEc0ZhRBk%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/FDA0003179558560000011.GIF?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=EU4QbJA6F3po1IhibXV7hTCMFNE%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/FDA0003179558560000021.GIF?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=q2y%2Fxt3cgwqv%2FNId3IWONYjJU9M%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/six/210726141019.gif?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=DJM58iBXtoIjQCxIf4Zno9w7SK8%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/six/bda0003179558570000021.gif?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=p02rwR78xGF%2BKGAqM0wOuFbrR7c%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/six/bda0003179558570000031.gif?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=f6IkUnOv7y%2FV0nSgDQbU2su8Zd4%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/six/bda0003179558570000032.gif?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=DukYchoR%2F5i%2FYE9IPOOlfWERuEE%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/six/bda0003179558570000041.gif?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=SXecVtGO42l1DqL0ZgVLD5%2BcVqw%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/six/bda0003179558570000042.gif?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=v24%2Bp10sENOlFHjzi%2BOi3kRFI3o%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/six/bda0003179558570000043.gif?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=FaqHibOKZnru7X%2BBvb133wOHNWg%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/six/bda0003179558570000051.gif?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=cs1LoNsFM%2BMPJ8iRV6RCP34lXnI%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/six/bda0003179558570000052.gif?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=9nqfKjEH4gTqH1dHmiTu3N10mPs%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/six/bda0003179558570000053.gif?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=W2i0AKTvwLfQBjQraLYHt3rXYDA%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/six/bda0003179558570000054.gif?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=RmU6PE8q6v6JUOC7%2BRClxQvfHkw%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/six/bda0003179558570000055.gif?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=fdTX7qyK8HnEF0KE44JE92PzTMM%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/six/bda0003179558570000056.gif?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=6BUtQJS086eMJN93f2CLwt74Nrc%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/six/bda0003179558570000061.gif?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=JuuBSNCmnA99HxOqwk03aAwPMA8%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/six/fda0003179558560000011.gif?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=NyQp%2FUc3QFG6GcMWbWp%2B9uiDroo%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      },
      {
        filePath: 'https://datacenter1-oss.oss-cn-shenzhen.aliyuncs.com//lii_pic/cn/-37/11372/3666a/sms/six/fda0003179558560000021.gif?Expires=1639031272&OSSAccessKeyId=LTAI5tA7rXhs5zWttMvzZNJZ&Signature=RnoN%2FF5Zj9zwEIVepAtnbWyRcb8%3D&x-oss-process=image%2Fresize%2Ch_750%2Cw_750%2Fformat%2Cpng',
        extend: 'GIF'
      }
    ]
  }
]
export {
  infoList, requestCols, tabList, fileList
}
